/**
 * The key of a plan's only route, or null when it has none or several.
 *
 * A single-route plan has no "whole trail" overview to step back to — there
 * are no route cards or day rows to pick the route from, so a deselected
 * single route would leave the route tools (manage control points, add
 * control points, map-match) unreachable. Everywhere the planner would
 * deselect (opening a hike, importing, re-slicing days, "back to all
 * routes") uses this so a lone route stays active, as if it had just been
 * selected in a multi-day plan. Pure.
 */
export function soleRouteKey(routes: { [routeKey: string]: unknown } | null | undefined): string | null {
  const keys = Object.keys(routes ?? {});
  return keys.length === 1 ? keys[0] : null;
}
